import React from 'react';
import { Eye, Download, ArrowUpDown, FileText } from 'lucide-react';
import './ReportsPage.css';

const ReportTable = ({ reports = [], onView, onDownload, sort, onSortChange }) => {
  const formatDate = (iso) => {
    if (!iso) return 'N/A';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return 'N/A';
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const formatTime = (iso) => {
    if (!iso) return 'N/A';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return 'N/A';
    return d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="rpt-wrap">
      <table className="rpt-table">
        <thead>
          <tr>
            <th>Patient Name</th>
            <th>Age</th>
            <th>Date</th>
            <th>Time</th>
            <th className="rpt-sortable" onClick={() => onSortChange(sort === 'newest' ? 'oldest' : 'newest')}>
              <span className="rpt-sort-label">
                Created <ArrowUpDown size={12} />
              </span>
            </th>
            <th>Status</th>
            <th className="rpt-actions-col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {reports.length === 0 && (
            <tr>
              <td colSpan="7" className="rpt-empty">
                <FileText size={22} />
                <span>No reports found. Complete a VitalScan and generate your first report.</span>
              </td>
            </tr>
          )}
          {reports.map((r) => (
            <tr key={r.id}>
              <td className="rpt-name">
                <span className="rpt-avatar">{r.patient_name ? r.patient_name.charAt(0).toUpperCase() : '?'}</span>
                <span className="rpt-name-text">{r.patient_name || 'N/A'}</span>
              </td>
              <td>{r.age ?? 'N/A'}</td>
              <td>{formatDate(r.created_at)}</td>
              <td>{formatTime(r.created_at)}</td>
              <td className="rpt-sort-val">{formatDate(r.created_at)}</td>
              <td>
                <span className="rpt-status">
                  <span className="rpt-status-dot" />
                  Ready
                </span>
              </td>
              <td>
                <div className="rpt-actions">
                  <button className="rpt-btn" title="View report" onClick={() => onView(r)}>
                    <Eye size={15} />
                    View
                  </button>
                  <button className="rpt-btn rpt-btn-download" title="Download PDF" onClick={() => onDownload(r)}>
                    <Download size={15} />
                    Download
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportTable;
